export default __webpack_public_path__ + "static/media/radio-deselected.b102d2f3.svg";